import { TextareaInput } from './textarea/textarea.input';
import { RadioInput } from './radio/radio.input';
import { SliderInput } from './slider/slider.input';
import { YesNoInput } from './yes_no/yes_no.input';
import { DropDown } from './dropdown/dropdown.input';
import { RatingInput } from './rating/raiting.input';
import { CheckboxInput } from './checkbox/checkbox.input';

export const getComponentByType = (type: string) => {
  switch (type) {
    case 'textarea':
      return TextareaInput;
    case 'radio':
      return RadioInput;
    case 'email':
      return TextareaInput;
    case 'number':
      return TextareaInput;
    case 'slider':
      return SliderInput;
    case 'textfield':
      return TextareaInput;
    case 'dropdown':
      return DropDown;
    case 'yes_no':
      return YesNoInput;
    case 'rating':
      return RatingInput;
    case 'checkbox':
      return CheckboxInput;
    case 'link':
      return TextareaInput;
    default:
      break;
  }
};
